import { ShoppingBagIcon } from "@/components/app-icons/Bag";
import { BookmarkIcon } from "@/components/app-icons/BookmarkSimple";
import { BarChartIcon } from "@/components/app-icons/ChartBar";
import { CelebrationIcon } from "@/components/app-icons/Confetti";
import { GiftIcon } from "@/components/app-icons/Gift";
import { HeadphonesIcon } from "@/components/app-icons/Headphones";
import { WishlistIcon } from "@/components/app-icons/Heart";
import { AddToPlaylistIcon } from "@/components/app-icons/ListPlus";
import { PremiumIcon } from "@/components/app-icons/Medal";
import { MicrophoneIcon } from "@/components/app-icons/Microphone";
import { MusicIcon } from "@/components/app-icons/MusicNote";
import { CollectionIcon, MusicNotesIcon } from "@/components/app-icons/MusicNotes";
import { PianoIcon } from "@/components/app-icons/PianoKeys";
import { MusicQueueIcon } from "@/components/app-icons/Playlist";
import { RadioIcon } from "@/components/app-icons/Radio";
import { RatingIcon } from "@/components/app-icons/Star";
import { SellIcon, StoreIcon } from "@/components/app-icons/Storefront";
import { OfferIcon } from "@/components/app-icons/Tag";
import { LabelIcon } from "@/components/app-icons/TagSimple";
import { TrophyIcon } from "@/components/app-icons/Trophy";
import { ReleaseIcon } from "@/components/app-icons/VinylRecord";
import { WaveformIcon } from "@/components/app-icons/Waveform";
import type { AppIcon } from "@/components/createAppIcon";

const LIST_ICON_BY_KEY: Record<string, AppIcon> = {
  music_note: MusicIcon,
  headphones: HeadphonesIcon,
  library_music: CollectionIcon,
  favorite: WishlistIcon,
  queue_music: MusicQueueIcon,
  piano: PianoIcon,
  mic: MicrophoneIcon,
  radio: RadioIcon,
  graphic_eq: WaveformIcon,
  equalizer: BarChartIcon,
  audiotrack: MusicNotesIcon,
  album: ReleaseIcon,
  star: RatingIcon,
  bookmark: BookmarkIcon,
  label: LabelIcon,
  sell: SellIcon,
  local_offer: OfferIcon,
  storefront: StoreIcon,
  shopping_bag: ShoppingBagIcon,
  redeem: GiftIcon,
  card_giftcard: GiftIcon,
  celebration: CelebrationIcon,
  workspace_premium: PremiumIcon,
  emoji_events: TrophyIcon,
  playlist_add: AddToPlaylistIcon,
};

export function getListIcon(value: string | null | undefined): AppIcon {
  return (value && LIST_ICON_BY_KEY[value]) || ReleaseIcon;
}
